import { TranslationKey } from 'app/core/i18n/translation-keys';

/**
 * Grouping criteria for business partners in sub-route assignment.
 * Values match the API endpoint parameter: groupBy
 */
export enum BPGroupingCriteria {
  /** No grouping - flat list view */
  NONE = 'NONE',

  /** Group by business partner group */
  BUSINESS_PARTNER_GROUP = 'businessPartnerGroup',

  /** Group by business partner sub-group */
  BUSINESS_PARTNER_SUB_GROUP = 'businessPartnerSubGroup',

  /** Group by route (territory) */
  ROUTE = 'route',

  /** Group by route area */
  ROUTE_AREA = 'routeArea',

  /** Group by sales office */
  SALES_OFFICE = 'salesOffice',

  /** Group by country (locationOne) */
  LOCATION_ONE = 'locationOne',

  /** Group by department (locationTwo) */
  LOCATION_TWO = 'locationTwo',

  /** Group by city (locationThree) */
  LOCATION_THREE = 'locationThree',

  /** Group by district (locationFour) */
  LOCATION_FOUR = 'locationFour',
}

/**
 * Grouped count data from count-by-bpfrequency endpoint (legacy)
 */
export interface BPGroupedCount {
  _id: string;
  name: string;
  count: number;
}

/**
 * Raw API response item from count-by-bpfrequency endpoint.
 * Can have id null and _id might not exist (e.g., "SIN SUBGRUPO").
 */
export interface BPGroupedApiItem {
  _id?: string;
  id?: number | null;
  name?: string;
  code?: string;
  totalBusinessPartners?: number;
  count?: number;
  businessPartners?: any[];
}

/**
 * Full grouped item from count-by-bpfrequency endpoint (mapped).
 * Contains the identifier (_id) needed for expand/drill-down.
 */
export interface BPGroupedItem {
  /** Identifier for the group - used for template tracking */
  _id: string;
  /** Original numeric ID from API - used for filtering on expand */
  id: number | null;
  /** Group name (e.g., "Guatemala", "Ruta Norte") */
  name: string;
  /** Group code (e.g., "GT", "RN001") */
  code: string;
  /** Count of business partners in this group */
  totalBusinessPartners: number;
  /** Business partners array (populated on expand) */
  businessPartners: any[];
}

/**
 * Response structure from count-by-bpfrequency endpoint
 */
export interface BPGroupedResponse {
  data: BPGroupedApiItem[];
  pageInfo: { total: number }[];
}

/**
 * Section configuration for grouping menu
 */
export interface BPGroupingSection {
  /** A translation key — compile-checked at the declaration site (`bp-grouping.constants.ts`). */
  name: TranslationKey;
  icon: string;
  options: BPGroupingCriteria[];
}
